export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white/98 backdrop-blur-md border-t border-cream-dark/40 shadow-[0_-2px_12px_rgba(0,0,0,0.06)]">
      <div className="flex items-center px-2 py-1.5 gap-1.5">
        <a
          href="https://wa.me/918861133745?text=Hi%2C%20I%27m%20interested%20in%20Confident%20Auriga.%20Please%20share%20more%20details."
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-green-600 text-white font-body font-semibold text-xs rounded-lg transition-all duration-300 hover:bg-green-500 hover:scale-[1.02] active:scale-[0.98]"
        >
          <i className="ri-whatsapp-line text-sm"></i>
          <span className="whitespace-nowrap">WhatsApp</span>
        </a>
        <a
          href="https://wa.me/918861133745?text=Hi%2C%20I%20would%20like%20to%20book%20a%20site%20visit%20at%20Confident%20Auriga.%20Please%20share%20available%20dates%20and%20timings."
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-gold text-primary font-body font-semibold text-xs rounded-lg transition-all duration-300 hover:bg-gold-light hover:text-primary hover:scale-[1.02] active:scale-[0.98]"
        >
          <i className="ri-calendar-check-line text-sm"></i>
          <span className="whitespace-nowrap">Book Visit</span>
        </a>
        <a
          href="tel:+918861133745"
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-primary text-white font-body font-semibold text-xs rounded-lg transition-all duration-300 hover:bg-primary/90 hover:scale-[1.02] active:scale-[0.98]"
        >
          <i className="ri-phone-line text-sm"></i>
          <span className="whitespace-nowrap">Call Now</span>
        </a>
      </div>
    </div>
  );
}